import { trackError } from './analytics'

/**
 * Initialize global error tracking with Firebase Analytics
 */
export const initErrorTracking = () => {
    // Store original console methods
    const originalConsoleError = console.error

    // Override console.error to track errors
    console.error = function(...args) {
        // Track the error in Firebase Analytics
        trackError('console_error', { message: args.length ? String(args[0]) : 'Unknown console error' })
        // Call the original console.error
        originalConsoleError.apply(console, args)
    }

    // Add window error event listener
    const handleGlobalError = (event: ErrorEvent) => {
        trackError('uncaught_error', {
            message      : event.message,
            source       : event.filename,
            lineNumber   : event.lineno,
            columnNumber : event.colno,
        })
    }

    // Add unhandled promise rejection tracking
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
        trackError('unhandled_promise_rejection', {
            reason: event.reason ? String(event.reason) : 'Unknown promise rejection',
        })
    }

    window.addEventListener('error', handleGlobalError)
    window.addEventListener('unhandledrejection', handleUnhandledRejection)

    return () => {
        // Clean up
        console.error = originalConsoleError
        window.removeEventListener('error', handleGlobalError)
        window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    }
}